import * as React from "react";
import {
    Button,
    FormGroup,
    Grid,
    Switch,
    TextField,
    FormControlLabel,
    FormControl,
    InputLabel, Select, MenuItem
} from "@material-ui/core";
import {API} from "aws-amplify";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {enableAutoRefillRequestDefault, IEnableAutoRefillRequest} from "./request/EnableAutoRefillRequest";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: IEnableAutoRefillRequest
    response: any
}

enum InputField {
    DAYS_SUPPLY,
    DRUG_ID,
    PERSON_ID,
    PROFILE_ID,
    PRESCRIPTION_ID,
}

class EnableAutoRefillSection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: enableAutoRefillRequestDefault,
            request: { priceSelectionPreference: 'LowestPrice', daysSupply: 30} as IEnableAutoRefillRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setPriceSelectionPreferences = this.setPriceSelectionPreferences.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>

                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Days Supply"
                                variant="outlined"
                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                value={ this.state.request.daysSupply || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DAYS_SUPPLY, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Drug Id"
                                variant="outlined"
                                value={ this.state.request.drugId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DRUG_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Person Id"
                                variant="outlined"
                                value={ this.state.request.personId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PERSON_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Profile Id"
                                variant="outlined"
                                value={ this.state.request.profileId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROFILE_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Prescription Id"
                                variant="outlined"
                                value={ this.state.request.prescriptionId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PRESCRIPTION_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <FormControl>
                                <InputLabel>Price Selection Preference</InputLabel>
                                <Select
                                    value={ this.state.request.priceSelectionPreference || 'LowestPrice' }
                                    style={{width: 400}}
                                    onChange={ this.setPriceSelectionPreferences }
                                >
                                    <MenuItem value="LowestPrice">
                                        <em>Lowest Price</em>
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 10 }
                            label="Enable Auto Refill Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Enable Auto Refill
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <Alert variant="filled" severity="info">
                        Auto refill enabled
                    </Alert>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IEnableAutoRefillRequest = this.state.request;

        switch (field) {
            case InputField.DAYS_SUPPLY: {
                updatedRequest.daysSupply = +event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.DRUG_ID: {
                updatedRequest.drugId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PERSON_ID: {
                updatedRequest.personId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PROFILE_ID: {
                updatedRequest.profileId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.PRESCRIPTION_ID: {
                updatedRequest.prescriptionId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setPriceSelectionPreferences(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IEnableAutoRefillRequest = this.state.request;
        updatedRequest.priceSelectionPreference = event.target.value
        this.setState({ request: updatedRequest });
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });
        let body: IEnableAutoRefillRequest;

        if (this.state.isJsonInput) {
            body = JSON.parse(this.state.jsonInput);
        } else {
            body = this.state.request;
        }

        const config = {
            body,
            headers: {}
        }

        this.callEnableAutoRefill(config);

        this.setState({ isLoading: false });
    }

    private callEnableAutoRefill(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/auto-refill/enable';

        console.log(config)
        API.post(apiName, path, config).then((enableAutoRefillResponse: any) => {
            console.log(enableAutoRefillResponse);

            this.setState({ response: enableAutoRefillResponse.isEnabled });
        }).catch((error) => {
            console.log(error);

            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default EnableAutoRefillSection;